import { Order } from 'entities/orders/model/types';
import { FC, useRef, useState } from 'react';
import { Flex } from 'shared/ui/flex';
import { MessageIcon } from 'shared/ui/icons/message';
import { NotesContainer, NotesTooltip } from './styles';

export const OrderNotesMarker: FC<{ order: Order }> = ({ order }) => {
	const containerRef = useRef<HTMLElement>(null);
	const [isShow, setShow] = useState(false);
	const [positionTooltip, setPositionTooltip] = useState({
		left: -100,
		top: -100,
	})

	const showTooltip = () => {
		if (containerRef.current) {
			setPositionTooltip({
				left: containerRef.current.getBoundingClientRect().left,
				top: containerRef.current.getBoundingClientRect().top,
			})
		}
		setShow(true)
	}

	const hideTooltip = () => {
		setShow(false)
	}


	return (
		<Flex $justify="flex-end" $cursor="pointer">
			<NotesContainer ref={containerRef} onMouseMove={showTooltip} onMouseLeave={hideTooltip}>
				{order.notes.length > 0 ? (
					<>
						{isShow && (
							<NotesTooltip style={{ right: window.innerWidth - positionTooltip.left - 34, bottom: window.innerHeight - positionTooltip.top + 16 }}>
								{order.notes}

								<svg style={{ position: 'absolute', bottom: '-8px', right: '16px' }} width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M9.23205 12C8.46225 13.3333 6.53775 13.3333 5.76795 12L1.00481 3.75C0.23501 2.41667 1.19726 0.75 2.73686 0.75L12.2631 0.75C13.8027 0.75 14.765 2.41667 13.9952 3.75L9.23205 12Z" fill="#A1AAC6" />
								</svg>
							</NotesTooltip>
						)}
						<MessageIcon />
					</>
				) : <></>}
			</NotesContainer>
		</Flex>
	);
};
